<div class="admin-content-container admin-navbar-container">
    <div class="notification-container">
        <!-- <img (click)="refresh()" class="notification-img" src="../../../../assets/images/Notification/alarm-bell.png" /> -->
        <span nz-icon nzType="reload" (click)="refresh()" nzTheme="outline"></span>
    </div>
</div>